import { useState, useCallback } from 'react';
import mapboxgl from 'mapbox-gl';
import type { MarketZoneId } from '@app/common/static-data/energy-markets';

export const useTabManager = () => {
  const [activeTab, setActiveTab] = useState<'list' | 'map'>('map');

  // Create a tab change handler factory that can be configured with dependencies
  const createTabChangeHandler = useCallback(
    (
      mapRef: React.MutableRefObject<mapboxgl.Map | null>,
      selectedZone: MarketZoneId | null,
      centerOnZone: (zoneId: string, animate?: boolean) => void,
    ) => {
      return (tab: 'list' | 'map') => {
        setActiveTab(tab);
        // Resize map when switching to map tab to ensure proper rendering and event handlers
        if (tab === 'map' && mapRef.current) {
          setTimeout(() => {
            if (mapRef.current) {
              mapRef.current.resize();
              // Ensure map interactions are properly enabled
              mapRef.current.getCanvas().style.cursor = '';

              // If there's a selected zone, center on it when switching to map view
              if (selectedZone) {
                centerOnZone(selectedZone, true);
              }
            }
          }, 100);
        }
      };
    },
    [],
  );

  return {
    activeTab,
    createTabChangeHandler,
  };
};
